function isDev() {
  return window.location.hostname !== 'veracity.london';
}

export default isDev;
